import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';

const LoadingScreen = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      height="60vh"
      alignItems="center"
      flexDirection="column"
    >
      <CircularProgress sx={{ mb: 2 }} />
      <Typography>Egy pillanat...</Typography>
    </Box>
  );
};

export default LoadingScreen;
